<template>
  <div class="account-login">
    <el-container>
      <el-main :class="getMainClass()">
        <transition name="slide-fade">
          <div class="bg-main">
            <router-view />
          </div>
        </transition>
      </el-main>
      <el-footer>
        <Footer></Footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from "vuex";
import ls from "local-storage";
import Footer from "@/views/layout/Footer";

export default {
  name: "LayoutMain",
  components: {
    Footer,
  },
  computed: {
    ...mapGetters("account", ["logged"]),
    ...mapGetters(["path", "full_path"]),
    isDetailSerarch() {
      let routes = ["product-detail"];
      return routes.includes(this.path);
    },
    isSerachList() {
      let routes = ["search-list"];
      return routes.includes(this.path);
    },
    isCart() {
      let routes = ["cart-create"];
      return routes.includes(this.path);
    },
    isOther() {
      let routes = ["other"];
      return routes.includes(this.path);
    },
  },
  data() {
    return {
      title: "",
      isBack: false,
      isLogout: false,
      urlBack: "",
    };
  },
  mounted() {
    console.log(this.path, 'pathhhh')
  },
  updated() {

  },
  methods: {
    ...mapActions("account", ["getAccountInfo"]),
    getMainClass() {

      return {
        'paddding0': this.path == 'chat-list',
      }
    },
    checkLoged() {
      let authen = ls.get("authen");
      if (!authen) {
        let routesNotRedirect = [
          "register",
          "register-success",
          "forgot-password",
          "",
          "reset-password",
          "reset-success",
          "order",
        ];
        if (!routesNotRedirect.includes(this.path)) {
          this.$router.push({ name: "account-login" });
        }
      } else {
        if (!this.logged) {
          this.getAccountInfo();
        }
      }
    },
  },
};
</script>

<style type="text/css" scoped></style>

<style type="text/css">
.account-login {
  overflow-x: hidden;
  height: 100vh;
  background-color: #effafe;
}

.el-container {
  width: 100%;
  height: 100vh;
}
.el-main {
  /*margin-bottom: 80px;*/
  padding-bottom: 100px !important;
}

.el-footer {
  padding: 0 !important;
  height: 80px !important;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 2;
}

.message-box-custom {
  width: unset !important;
}

.msgb-cancel {
  background: #f4f4f4 !important;
  border-radius: 24px !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.msgb-confirm {
  background: #26b01c !important;
  border-radius: 24px !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.el-message-box {
  width: 80% !important;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}

.el-date-table .el-date-table__row .prev-month {
  pointer-events: none;
  opacity: 0.4;
}

.el-date-table .el-date-table__row .next-month {
  pointer-events: none;
  opacity: 0.4;
}

.el-dropdown {
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}

.bd-bottom-05-ec {
  border-bottom: 0.5px solid #ececec;
}

.bd-top-05-ec {
  border-top: 0.5px solid #ececec;
}
.el-main-padding {
  padding-left: 10px;
  padding-right: 10px;
}
.el-main-search {
  padding: 0 !important;
}
.d-none {
  display: none;
}
.el-main-other {
  background: #f1f7ff;
  padding: 15px !important;
}
  .paddding0 {
    padding: 0 !important;
  }
</style>
